import moment from 'moment';

export function isTodayInMonthlyRepeatOn(
  repeatOns: { position: string; day: string }[]
): boolean {
  const today = moment().startOf('day');
  const todayName = today.format('dddd');

  const positionMap = {
    First: 1,
    Second: 2,
    Third: 3,
    Fourth: 4,
    Last: -1,
  };

  for (const repeat of repeatOns) {
    if (repeat.day !== todayName) continue;

    const position = repeat.position;
    const monthStart = today.clone().startOf('month');
    const current = monthStart.clone();

    let count = 0;
    let totalForThisWeekday = 0;

    while (current.month() === today.month()) {
      if (current.format('dddd') === todayName) {
        totalForThisWeekday++;
      }
      current.add(1, 'day');
    }

    const currentAgain = monthStart.clone();
    count = 0;
    while (currentAgain.isSameOrBefore(today)) {
      if (currentAgain.format('dddd') === todayName) {
        count++;
        if (currentAgain.isSame(today, 'day')) {
          const isMatch =
            (position === 'Last' && count === totalForThisWeekday) ||
            positionMap[position] === count;

          if (isMatch) return true;
        }
      }
      currentAgain.add(1, 'day');
    }
  }

  return false;
}